import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaLock } from "react-icons/fa";
import "./Navbar.css";

const menu = [
  { label: "Home", path: "/" },
  { label: "About", sub: [
    { label: "History", path: "/about/history" },
    { label: "Vision and Mission", path: "/about/vision-mission" },
    { label: "Correspondent Message", path: "/about/correspondent-message" },
    { label: "Principal Message", path: "/about/principal-message" }
  ] },
    { label: "Admission", sub: [
      { label: "Admission Process", path: "/admission/process" },
      { label: "Rules And Regulations", path: "/admission/rules" },
      { label: "Scholarship", path: "/admission/scholarship" }
    ] },
  { label: "Academics", sub: [
    { label: "Kindergarten School", path: "/academics/kindergarten" },
    { label: "Secondary School", path: "/academics/secondary" }
  ] },
  { label: "Administrations", sub: [
    { label: "Teaching Staff", path: "/administrations/teaching-staff" },
    { label: "Non-Teaching Staff", path: "/administrations/non-teaching-staff" }
  ] },
  { label: "Facilities", sub: [
    { label: "Lab", path: "/facilities/lab" },
    { label: "Library", path: "/facilities/library" },
    { label: "Transportation", path: "/facilities/transport" }
  ] },
  { label: "Activities", sub: [
    { label: "Scout", path: "/activities/scout" },
    { label: "Junior Red Cross", path: "/activities/junior-red-cross" }
  ] },
  { label: "Alumni", path: "/alumni" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact Us", path: "/contact" }
];

const Navbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const navigate = useNavigate();

  const toggleSubmenu = (label) => {
    setOpenSubmenu(openSubmenu === label ? null : label);
  };

  const handleLoginClick = () => {
    navigate("/admin/login");
  };

  return (
    <nav className="sdlcreative-navbar">
      <div className="sdlcreative-nav-inner">
      

        {/* Hamburger (mobile) */}
        <button
          className="sdlcreative-hamburger"
          aria-label="Toggle menu"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <FaBars size={24} />
        </button>

        {/* Right: Menu (desktop) */}
        <div className="sdlcreative-menu-wrap">
          <ul className="sdlcreative-menu">
            {menu.map((item) => (
              <li key={item.label} className="sdlcreative-menu-item">
                {item.sub ? (
                  <>
                    <span className="sdlcreative-menu-label">{item.label}</span>
                    <ul className="sdlcreative-submenu">
                      {item.sub.map((sub) => (
                        <li key={sub.label} className="sdlcreative-submenu-item">
                          <Link to={sub.path} className="sdlcreative-link">{sub.label}</Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link to={item.path} className="sdlcreative-link">{item.label}</Link>
                )}
              </li>
            ))}
            <li className="sdlcreative-menu-item">
              <button 
                className="sdlcreative-login-btn" 
                onClick={handleLoginClick}
                aria-label="Admin Login"
                title="Admin Login"
              >
                <FaLock size={20} />
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Overlay + Sidebar (mobile) */}
      <div
        className={`sdlcreative-overlay ${sidebarOpen ? "open" : ""}`}
        onClick={() => setSidebarOpen(false)}
        aria-hidden={!sidebarOpen}
      />

      <aside className={`sdlcreative-sidebar ${sidebarOpen ? "open" : ""}`} aria-hidden={!sidebarOpen}>
        <nav className="sdlcreative-sidebar-nav">
          <ul className="sdlcreative-sidebar-menu">
            {menu.map((item) => (
              <li key={item.label} className={`sdlcreative-sidebar-item ${openSubmenu === item.label ? "open" : ""}`}>
                {item.sub ? (
                  <>
                    <button 
                      className="sdlcreative-sidebar-label"
                      onClick={() => toggleSubmenu(item.label)}
                      style={{ width: "100%", textAlign: "left", border: "none", background: "transparent", cursor: "pointer" }}
                    >
                      {item.label}
                    </button>
                    <ul className="sdlcreative-sidebar-submenu">
                      {item.sub.map((sub) => (
                        <li key={sub.label} className="sdlcreative-sidebar-subitem">
                          <Link to={sub.path} className="sdlcreative-sidebar-link" onClick={() => setSidebarOpen(false)}>{sub.label}</Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link to={item.path} className="sdlcreative-sidebar-link" onClick={() => setSidebarOpen(false)}>{item.label}</Link>
                )}
              </li>
            ))}
            <li className="sdlcreative-sidebar-item">
              <button 
                className="sdlcreative-sidebar-login-btn" 
                onClick={() => {
                  handleLoginClick();
                  setSidebarOpen(false);
                }}
                aria-label="Admin Login"
              >
                <FaLock size={20} /> Admin Login
              </button>
            </li>
          </ul>
        </nav>
      </aside>
    </nav>
  );
};

export default Navbar;
